export enum GTM_KEY {
  FBP = 'fbp',
  GA = 'ga',
  TTD = 'ttd',
  TTP = 'ttp',
  AF = 'af',
  LIP = 'lip',
  YH = 'yh',
  SMB_HUB = 'smbhub',
  BP = 'bp',
  RTBHOUSE = 'rtbhouse',
  TT_ADS = 'ttads',
  LINKEDIN = 'linkedin',
  REDDIT = 'reddit',
  TWITTER = 'twitter',
  XANDR = 'xandr'
}
